import { ObservableFromFetch } from "../ObservableFromFetch"

export default function UserPasswordReset(email: string, link: string, isForgot: boolean = true) {
  const requestBody: string = JSON.stringify({
    InvitationLink: link,
    IsForgotPassword: isForgot,
    UserName: email
  })
  return ObservableFromFetch<string>("FFOrderAccount/ChangeUserPassword", requestBody)
}